goog.provide("shadow.js.shim.module$src$svg$objects$clock_svg$default");
shadow.js.shim.module$src$svg$objects$clock_svg$default = shadow.js.shim.module$src$svg$objects$clock_svg.default;
